import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalsService {

  // Local
  //  dataUrl = 'http://localhost/salud-cannabis/'

  // Development
  // dataUrl = 'https://salud-mc-api-prop-fbf3c7c2d9haevfe.westus2-01.azurewebsites.net/';
  // sa = 'https://xworkssa.blob.core.windows.net/uploadedfiles';

  // Production
  dataUrl = 'https://as-salud-mc-api-axdqdrdadwcjajff.eastus2-01.azurewebsites.net/';
  sa = 'https://saludcannabislicprod.blob.core.windows.net/uploadedfiles';


  loginData = {
    access_token: '',
  };
}
